export default function Security() {
  const securityFeatures = [
    {
      icon: 'ri-lock-password-line',
      title: 'End-to-End Encryption',
      description: 'All your data is encrypted from the moment it leaves your device until it reaches its destination.'
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Secure Protocols',
      description: 'Support for OpenVPN, IKEv2, and WireGuard protocols for maximum security and performance.'
    },
    {
      icon: 'ri-file-shield-line',
      title: 'No Activity Logs',
      description: 'We do not monitor, record, or store logs of your activity. Your privacy is guaranteed.'
    },
    {
      icon: 'ri-radar-line',
      title: 'Threat Protection',
      description: 'Built-in malware and phishing protection keeps you safe from online threats automatically.'
    },
    {
      icon: 'ri-wifi-line',
      title: 'Public WiFi Security',
      description: 'Stay protected on public networks with automatic encryption of all your internet traffic.'
    },
    {
      icon: 'ri-fingerprint-line',
      title: 'Multi-Device Support',
      description: 'Secure all your devices simultaneously with one account across Windows, Mac, iOS, and Android.'
    }
  ];

  return (
    <section id="security" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-1.5 bg-purple-100 rounded-full">
            <span className="text-purple-600 text-xs font-semibold uppercase tracking-wider">Your Safety Matters</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Comprehensive Security Features
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Multiple layers of protection working together to ensure your online activities remain private and secure at all times.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {securityFeatures.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-purple-600 rounded-xl mb-5 group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
